import { ApexOptions } from "apexcharts";
import axios from "axios";
import ReactApexChart from "react-apexcharts";
import { URL_API } from "../../utils/helper/helpers";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

type Materiel = { [key: string]: any }


const Chart = ({ chartData }: { chartData: number[] }) => {
    const totalProjectChartData: ApexOptions = {
        series: chartData,
        chart: {
            type: "donut",
            height: 260,
        },
        plotOptions: {
            pie: {
                expandOnClick: false,
                startAngle: -90,
                endAngle: 90,
                offsetY: 10,
                donut: {
                    size: "75%",
                    labels: {
                        show: true,
                        name: {
                            offsetY: -10,
                        },
                        value: {
                            offsetY: -50,
                        },
                        total: {
                            show: true,
                            fontSize: "14px",
                            fontFamily: "Outfit",
                            fontWeight: 400,
                            label: "Tonnes",
                            color: "#9B9B9B",
                            formatter: (w) => {
                                // Formatteur pour afficher le total
                                return chartData.reduce((a, b) => a + b, 0).toString();
                            },
                        },
                    },
                },
                customScale: 1,
                offsetX: 0,
            },
        },
        grid: {
            padding: {
                bottom: -120,
            },
        },
        legend: {
            show: false,
        },
        dataLabels: {
            enabled: false,
        },
        colors: ['#43B9B2', '#2E8DD3', '#FD7E40', '#2F4F4F'], // Couleurs personnalisées
    };

    return (
        <div>
            <ReactApexChart
                options={totalProjectChartData}
                series={chartData}
                type="donut"
                height={260}
            />
        </div>
    );
};
export default Chart

export const validerUnPaiment = ({ id_paiement, id_versement }: { id_paiement: number, id_versement: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/valider-paiement`, { id_paiement, id_versement }, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.success(response.data.success)
            onSuccess();
        }

    }).catch(error => {
        toast.info(error.response.data.message)

    })
}

export const deletePaiement = ({ id, fournisseur }: { id: number, fournisseur: string }, onSuccess: () => void) => {
   const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/supprimer-paiement/${id}/${fournisseur}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        console.log(error.response);
        if (error.response.status === 403) { // s'il sagit du paiement initial
            toast.info(error.response.data.message)
        }
        if(error.response.status === 404){ // paiement introuvable
            toast.info(error.response.data.message);
        }
        if (error.response.status === 500) {
            console.log(error.response.data);
            toast.info(error.response.data.message)
        }
    })
}

export const deletePaiementTransitaire = ({ id }: { id: number }, onSuccess: () => void) => {
   const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/supprimer-paiement-transitaire/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 403) { // s'il sagit du paiement initial
            toast.info(error.response.data.message)
        }
        if(error.response.status === 404){ // paiement introuvable
            toast.info(error.response.data.message);
        }
        if (error.response.status === 500) {
            console.log(error.response.data);
            toast.info(error.response.data.message)
        }
    })
}

export const deleteNumBon = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/num-bon/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 400) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })
}

export const deleteVersement = ({ id }: { id: number }, onSuccess: () => void) => {
    const Token = JSON.parse(localStorage.getItem("login")!);
    axios.post(`${URL_API}/versement/destroy/${id}`, {}, {
        headers: {
            Authorization: `Bearer ${Token}`
        }
    }).then(response => {

        if (response.data.success) {
            toast.info(response.data.message)
            onSuccess();
        }

    }).catch(error => {
        if (error.response.status === 400) {
            toast.info(error.response.data.message)
        }
        if (error.response.status === 500) {
            toast.info(error.response.data.message)
        }
    })
}

